import Button from 'devextreme/ui/button';
import './saveButtonDefaults.css';

// Include legacy popup toolbars and form/grid buttons created by DevExtreme.
export function protectSaveButton({ component, element }) {
    let locked = false;
    let disposed = false;
    let internal = false;
    let wrapped;
    let text;
    let disabled;
    const write = (options) => {
        internal = true;
        try { component.option(options); } finally { internal = false; }
    };
    const install = () => {
        const handler = component.option('onClick');
        if (handler === wrapped || typeof handler !== 'function') return;
        wrapped = function (event) {
            if (locked) return;
            const label = component.option('text');
            if (component.option('icon') !== 'save' && !/kaydet|save/i.test(String(label || ''))) {
                return handler.call(this, event);
            }
            locked = true;
            text = label;
            disabled = component.option('disabled');
            element.classList?.add('point-save-busy');
            write({ disabled: true, text: 'Kaydediliyor…' });
            const cooldown = new Promise(resolve => setTimeout(resolve, 500));
            const release = () => {
                locked = false;
                if (disposed) return;
                element.classList?.remove('point-save-busy');
                write({ disabled, text });
            };
            try {
                const result = handler.call(this, event);
                return Promise.allSettled([cooldown, Promise.resolve(result)]).then(release);
            } catch (error) {
                cooldown.then(release);
                throw error;
            }
        };
        write({ onClick: wrapped });
    };
    component.on('disposing', () => { disposed = true; });
    component.on('optionChanged', (event) => {
        if (internal) return;
        if (event.name === 'onClick') install();
        if (locked && (event.name === 'text' || event.name === 'disabled')) {
            if (event.name === 'text') text = event.value;
            else disabled = event.value;
            write({ disabled: true, text: 'Kaydediliyor…' });
        }
    });
    install();
}

Button.defaultOptions({ options: { onInitialized: protectSaveButton } });
